import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_left_icon",
  "use": "icon-arrow_left_icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_left_icon\"><g id=\"icon-arrow_left_icon_åå·¦\"><path id=\"icon-arrow_left_icon_Vector\" d=\"M8.70625 7.92626L5.40625 4.62626L6.34892 3.68359L10.5916 7.92626L6.34892 12.1689L5.40625 11.2263L8.70625 7.92626Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol